import { adminHttpClient } from '../../commons/adminHttpClient'
import { BenefitDesignStatus } from '../../../domain/benefit/benefitDesignStatus'
import AllowanceType from 'domain/benefit/allowanceType'
import { NamedItem } from 'domain/common/namedItem'

export interface BenefitDetails {
  id: string
  startDate: string
  endDate: string
  renewalNotificationDate?: string
  allowanceType: AllowanceType
  sameClassForAll: boolean
  benefitDesignStatus: BenefitDesignStatus
  allowToTriggeringEarlyRunout: boolean
  allowCancelRunout: boolean
  productClasses: ProductClass[]
  restrictedExpenseCategories: NamedItem[]
  runOutDays: number
}

export interface ProductClass {
  id: string
  name: 'string'
  totalEmployeesAssigned: 0
  designCompleted: true
}

const getBenefitDetails = (planPeriodId: string): Promise<BenefitDetails> => {
  return adminHttpClient.get(`/csi/Companies/benefit/${planPeriodId}`)
}

export default getBenefitDetails
